import * as angular from 'angular';

export class StorageOffersService {
    public offerDeletedSuccessfully: boolean = false;
}

angular.module('app').service('storageOffersService', StorageOffersService);
